<template>
  <main class="pb-5">
    <CategoryMainHeader v-if="isMdAndDown" class="sticky left-0 top-0 z-20 mb-4 bg-primary" />
    <div v-if="categories && categoriesInitialized" class="flex flex-col gap-2">
      <template v-for="(category, index) in categories" :key="category.id">
        <SearchResultsCategory
          :value="category"
          :max-items-desktop="4"
          :max-items-mobile="5"
          @toggle="router.push({ name: 'CategoryItemView', params: { id: category.id } })"
        />
        <UiHorizontalRule v-if="index < categories.length - 1" />
      </template>
    </div>
    <UiContainer v-else>
      <SearchResultsCategorySkeleton v-for="skeleton in 3" :key="skeleton" class="mb-9 !px-0" />
    </UiContainer>
    <UiEmptySearch
      v-if="categories && categories.length === 0"
      class="absolute h-full justify-center inset-center"
    />
  </main>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { CategoryMainHeader } from '@/3_widgets/Category'
import { SearchResultsCategorySkeleton, SearchResultsCategory } from '@/3_widgets/Search'
import { useCategory } from '@/5_entities/Category'
import { useReloadOnConfigurationUpdate } from '@/5_entities/Configuration'
import { useBreakpoint } from '@/6_shared/lib'
import { UiContainer, UiEmptySearch, UiHorizontalRule } from '@/6_shared/ui'

const { categories, categoriesInitialized } = storeToRefs(useCategory())
const { getAllCategories } = useCategory()
const {
  md: [_, isMdAndDown]
} = useBreakpoint()

const router = useRouter()

useReloadOnConfigurationUpdate(() => getAllCategories())
onBeforeMount(() => getAllCategories())
</script>
